import { render, staticRenderFns } from "./OtpByRoute.vue?vue&type=template&id=98925988&scoped=true"
import script from "./OtpByRoute.vue?vue&type=script&lang=js"
export * from "./OtpByRoute.vue?vue&type=script&lang=js"
import style0 from "./OtpByRoute.vue?vue&type=style&index=0&id=98925988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98925988",
  null
  
)

export default component.exports